import HeadTittle from "../../../../../../../components/HeadTittle";
import DivContainerBody from "../../../../../../../components/DivContainerBody";
import StepperTabs from "../../../../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../../../../components/StepperTabs/StepTab";
import {CREATE_STEP} from "../../../../../Traffic/Manage/Model/Model";
import {ButtonNextStep, ButtonPrevStep} from "../../../../../../../components/buttons/ButtonNavigation";
import {toast} from "react-toastify";
import ActiveScheduleStep from "../../../../../Traffic/Manage/SubComponents/ActiveSheduleStep";
import DefineAreaStep from "../../../../../Traffic/Manage/SubComponents/DefineAreaStep";
import DetailsStep from "./DetailsStep";
import GeofenceSummary from "./GeofenceSummary";
import CreateGeofenceAttendanceApp from "../Functionality/CreateGeofenceAttendanceApp";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 22 de 01 de 2026
 */

const CreateGeofenceAttendance = () => {
    const {
        t,
        activeStep,
        setActiveStep,
        steps,
        handleStepChange,
        handleStepSetUp,
        setDayArray,
        dayArray,
        handleAdd,
        item,
        emptyFields,
        handleChange,
        setItem,
        geofences,
        setGeofences,
        latitude,
        setLatitude,
        longitude,
        setLongitude,
        handleOnBack,
        selectedList,
        setSelectedList,
        isCloseTimeInvalid,
        isEqualTimes,
        disabled
    } = CreateGeofenceAttendanceApp();

    return (
        <>
            <HeadTittle onBack={handleOnBack} name={'create'} />
            <DivContainerBody>
                <>
                    <StepperTabs
                        id={null}
                        disabled={false}
                        steps={steps}
                        activeStep={activeStep}
                        isStepOptional={() => {}}
                        setActiveStep={setActiveStep}
                        handleStepChange={handleStepChange}
                    >
                        <StepTab index={CREATE_STEP.DETAILS} activeStep={activeStep} normalHeight={true}>
                            <DetailsStep
                                t={t}
                                item={item}
                                setItem={setItem}
                                disabled={disabled}
                                emptyFields={emptyFields}
                                handleChange={handleChange}
                                selectedList={selectedList}
                                setSelectedList={setSelectedList}
                            />
                            <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6 mb-60px'>
                                <ButtonNextStep
                                    id='btn_cga_next_schedule'
                                    text='next'
                                    click={() => {
                                        if (handleStepSetUp()) {
                                            setActiveStep((prevStep) => prevStep + 1);
                                        }
                                    }}
                                />
                            </div>
                        </StepTab>
                        <StepTab index={CREATE_STEP.ACTIVE_SCHEDULE} activeStep={activeStep} normalHeight={true}>
                            <ActiveScheduleStep
                                item={item}
                                t={t}
                                handleChange={handleChange}
                                emptyFields={emptyFields}
                                dayArray={dayArray}
                                setDayArray={setDayArray}
                                setItem={setItem}
                                disabled={disabled}
                                isCloseTimeInvalid={isCloseTimeInvalid}
                                isEqualTimes={isEqualTimes}
                                formatValue={false}
                            />
                            <div className='d-flex justify-content-between px-0 mt-3'>
                                <ButtonPrevStep
                                    id={'btn_cga_back_active_schedule'}
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cga_next_area'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => {
                                        if (handleStepSetUp()) {
                                            setActiveStep((prevStep) => prevStep + 1);
                                        }
                                    }}
                                />
                            </div>
                        </StepTab>
                        <StepTab index={CREATE_STEP.DEFINE_AREA} activeStep={activeStep} normalHeight={true}>
                            {activeStep === CREATE_STEP.DEFINE_AREA &&
                            <>
                                <div className={"col-12"}>
                                    <DefineAreaStep
                                        t={t}
                                        geofences={geofences}
                                        setGeofences={setGeofences}
                                        latitude={latitude}
                                        setLatitude={setLatitude}
                                        longitude={longitude}
                                        setLongitude={setLongitude}
                                        emptyFields={emptyFields}
                                        item={item}
                                        setItem={setItem}
                                        center={[latitude, longitude]}
                                    />
                                </div>

                                <div className='d-flex justify-content-between px-0 mt-3'>
                                    <ButtonPrevStep
                                        id='btn_cga_back_define_area'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_cga_next_summary'
                                        text='next'
                                        disabled={activeStep === steps.length - 1}
                                        click={() => {
                                            if (handleStepSetUp()) {
                                                setActiveStep((prevStep) => prevStep + 1);
                                            } else {
                                                toast.warn(t('please_fill_all_fields'));
                                            }
                                        }}
                                    />
                                </div>
                            </>
                            }
                        </StepTab>
                        <StepTab index={CREATE_STEP.SUMMARY} activeStep={activeStep} normalHeight={true}>
                            {activeStep === CREATE_STEP.SUMMARY &&
                            <>
                                <GeofenceSummary
                                    item={item}
                                    dayArray={dayArray}
                                    t={t}
                                    geofences={geofences}
                                    center={[latitude, longitude]}
                                />
                                <div className='d-flex justify-content-between px-0 mb-2'>
                                    <ButtonPrevStep
                                        id='btn_cga_back_summary'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_cga_create'
                                        text='create'
                                        click={() => {
                                            handleAdd();
                                        }}
                                    />
                                </div>
                            </>
                            }
                        </StepTab>
                    </StepperTabs>
                </>
            </DivContainerBody>
        </>
    );
};

export default CreateGeofenceAttendance
